import { render, staticRenderFns } from "./BtModal.vue?vue&type=template&id=d518288a&scoped=true&"
import script from "./BtModal.vue?vue&type=script&lang=js&"
export * from "./BtModal.vue?vue&type=script&lang=js&"
import style0 from "./BtModal.vue?vue&type=style&index=0&id=d518288a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518288a",
  null
  
)

export default component.exports